import { get } from 'lodash-es';

import { QuoteData } from '@model/quotation.model';

export function transformQuoteFormToQuoteData(quoteFormValue: any): QuoteData {
  return {
    type: get(quoteFormValue, 'type', null),
    channelType: get(quoteFormValue, 'channelType', null),
    imdCode: get(quoteFormValue, 'imdCode', null),
    aoMember: get(quoteFormValue, 'aoMember', null),
    insuranceType: get(quoteFormValue, 'insuranceType', null),
    insurancePlan: get(quoteFormValue, 'insurancePlan', null),
    period: get(quoteFormValue, 'period', null),
    schoolName: get(quoteFormValue, 'schoolName', null),
    travelType: get(quoteFormValue, 'travelType', null),
    durationPeriod: get(quoteFormValue, 'durationPeriod', null),
    from: get(quoteFormValue, 'from', null),
    to: get(quoteFormValue, 'to', null),
    fromDate: get(quoteFormValue, 'fromDate', null),
    toDate: get(quoteFormValue, 'toDate', null),
    numPeople: get(quoteFormValue, 'numPeople', null),
    duration: get(quoteFormValue, 'duration', null),
    directDiscount: get(quoteFormValue, 'directDiscount', null),
    discountRate: get(quoteFormValue, 'discountRate', null),
    dateWhenGetPrice: null,
    quotationNumber: get(quoteFormValue, 'quotationNumber', null)
  };
}
